import React from 'react';

import { useGetPlanningPeriodsQuery } from 'state/apiSlice';

import { OverflowLabel } from './OverflowLabel';
import { TaskBarComponent } from './TaskBar';
import { BaseMonthPicker } from './TypicalMonthPicker';

export function PlanningMonthPicker({
  disabled = false,
}: {
  disabled?: boolean;
}) {
  return (
    <TaskBarComponent>
      <OverflowLabel id="planning-month-input-label">
        Period: &nbsp;
        <BaseMonthPicker
          querier={useGetPlanningPeriodsQuery}
          disabled={disabled}
        />
      </OverflowLabel>
    </TaskBarComponent>
  );
}
